import { getLabelMessage } from '@gef-ui/localization/messages';

/**
 * Open new window with security emphasis
 * {@link https://mathiasbynens.github.io/rel-noopener/}
 *
 * @param {String} url
 * @return window
 */
const windowOpen = (url, keepOpener) => {
	const newWindow = window.open();
	if (!keepOpener) {
		newWindow.opener = null;
	}
	newWindow.location = url;

	return newWindow;
};

export const openNewTab = (
	newWindow,
	promise,
	loadingMsg = 'externalLinks:exitLinkLoading',
	errorMsg = 'externalLinks:exitLinkError',
) => {
	newWindow.document.write(getLabelMessage(loadingMsg));

	// set focus on new tab for IE
	// newWindow.focus() does not work
	const clickMsg = setTimeout(() => {
		newWindow.document.write();
	}, 3000);

	return promise.then(
		(res) => {
			window.clearTimeout(clickMsg);
			return res;
		},
		(err) => {
			console.error(err);
			window.clearTimeout(clickMsg);
			newWindow.document.write(getLabelMessage(errorMsg));
			throw err;
		},
	);
};

export const scrollTo = (page, x, y) => {
	document.getElementById(page).scrollTo(x, y);
};

export default windowOpen;
